/*
 * Images on the site's own storage CDN (any *.cdn.modulify.website host) and
 * local files in public/ go through Next's image optimizer, which is allowed
 * for those hosts in next.config.ts. Any other address is shown as it is, so
 * an outside URL pasted in the CMS never breaks a page.
 */

const CDN_HOST_SUFFIX = '.cdn.modulify.website'

export const isOptimizableImage = (src: string): boolean => {
    if (src.startsWith('/')) return !src.startsWith('//')

    try {
        const { protocol, hostname } = new URL(src)

        return protocol === 'https:' && hostname.endsWith(CDN_HOST_SUFFIX)
    }
    catch {
        return false
    }
}
